import { Box, Stack, Typography } from 'ui';
import { CameraEnhance } from 'ui/icons';

export const StepTwo = ({ children }: { children: JSX.Element }) => {
  return (
    <Stack alignItems="center" gap={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontWeight="bold">Take photos handsfree!</Typography>
        <CameraEnhance />
      </Box>

      <Typography textAlign="center">
        Put the phone down <strong>at an angle</strong> on a surface to pause auto capture.
      </Typography>

      {children}

      <Typography textAlign="center">
        Tap the auto capture button ‘<strong>OFF</strong>’ to stop taking photos automatically.
      </Typography>
    </Stack>
  );
};
